import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Popover, Button, Select } from 'antd';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faTimes } from '@fortawesome/pro-regular-svg-icons';
import style from './index.scss';

import ControlWithLabel from '../../common/ControlWithLabel';
import { startCase } from '../../../../util/lodashlike';

function SortComponent({
  widgetItemOperations,
  applySortingHandler,
  selectedValue,
  iconStyle
}) {
  const [isVisible, setisVisible] = useState(false);
  const [sortableKeys, setSortableKeys] = useState([]);
  const [selectedSort, setSelectedSort] = useState({});
  const [btnStatus, setBtnStatus] = useState(true);

  useEffect(() => {
    getSortableKeys();
  }, [widgetItemOperations]);

  useEffect(() => {
    setSelectedSort(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    if (selectedSort?.columnName) {
      setBtnStatus(false);
    } else {
      setBtnStatus(true);
      if (selectedValue?.columnName) {
        applySortingHandler({});
        hidePopUp();
      }
    }
  }, [selectedSort]);

  const showPopUp = () => {
    setisVisible(true);
  };

  const hidePopUp = () => {
    setisVisible(false);
  };

  const handleOnVisibleChange = (visibility) => {
    setisVisible(visibility);
  };

  const getSortableKeys = () => {
    const keys = [];
    if (widgetItemOperations) {
      widgetItemOperations.forEach((item) => {
        keys.push(item);
      });
    }
    setSortableKeys(keys);
  };

  const handleOnChange = (selectedOption, key) => {
    const obj = { columnName: key, operator: selectedOption.value };
    setSelectedSort(selectedOption.value ? obj : {});
  };

  const sortHandler = () => {
    applySortingHandler(selectedSort);
    hidePopUp();
  };

  const renderSortItem = (item, selectedSortItem) => {
    let itemLabel = startCase(item.itemName);

    let options = [
      { label: 'Highest to Lowest', value: 'DESC' },
      { label: 'Lowest to Highest', value: 'ASC' }
    ];
    if (item.key == 'LAST_UPDATED_TIMESTAMP') {
      options = [
        { label: 'Latest to Earliest', value: 'DESC' },
        { label: 'Earliest to Latest', value: 'ASC' }
      ];
    }
    if (item.key == 'CREATED_TIMESTAMP' || item.key == 'ALERT_DATE') {
      options = [
        { label: 'Newest to Oldest', value: 'DESC' },
        { label: 'Oldest to Newest', value: 'ASC' }
      ];
    }
    if (item.dataType == 'NAME') {
      options = [
        { label: 'Z to A', value: 'DESC' },
        { label: 'A to Z', value: 'ASC' }
      ];
    }
    const sortByOption = { label: 'Sort by', value: '' };
    const optionsArray = [sortByOption, ...options];
    const defaultValue = { value: '' };
    let selectedValue = defaultValue;

    if (selectedSortItem && selectedSortItem.columnName == item.key) {
      selectedValue = { value: selectedSortItem.operator };
    }

    return (
      <div className={style.item} key={item.itemName}>
        <label>{itemLabel}</label>
        {options && (
          <Select
            defaultValue={defaultValue}
            labelInValue
            onChange={(value) => handleOnChange(value, item?.key)}
            options={optionsArray}
            value={selectedValue}
          />
        )}
      </div>
    );
  };

  const popoverContent = () => {
    return (
      <div className={style.pop}>
        <div className={style.pop_head}>
          <h6>Sort</h6>
          <div id="faTimesIcon" onClick={hidePopUp}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </div>
        <div className={style.pop_content}>
          <div className={style.pop_content__card}>
            <div className={style.pop_content__card_header}>
              <span className={style.pop_content__card_header__label}>
                Field
              </span>
              <span className={style.pop_content__card_header__label}>
                Sort By
              </span>
            </div>
            <div className={style.pop_content__card_body}>
              {sortableKeys.map((item) => renderSortItem(item, selectedSort))}
            </div>
          </div>
        </div>
        <div className={style.pop_footer}>
          <Button onClick={() => setSelectedSort({})} disabled={btnStatus}>
            Clear
          </Button>
          <Button onClick={sortHandler} type="primary" disabled={btnStatus}>
            Apply
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className={style.wrapper}>
      <ControlWithLabel label="Sort">
        <Popover
          content={popoverContent}
          visible={isVisible}
          trigger="click"
          onVisibleChange={handleOnVisibleChange}
          placement="bottomRight">
          <div
            style={iconStyle}
            id="faSortIcon"
            className={style.iconWrapper}
            onClick={showPopUp}>
            <FontAwesomeIcon icon={faSort} />
          </div>
        </Popover>
      </ControlWithLabel>
    </div>
  );
}

SortComponent.propTypes = {
  widgetItemOperations: PropTypes.array.isRequired,
  applySortingHandler: PropTypes.func.isRequired,
  selectedValue: PropTypes.object.isRequired
};

export default SortComponent;
